import { useMutation } from '@tanstack/react-query';
import { initPaymentMethodRegistration } from '@/services/subscription.service';
import type { NicePayAuthParams, RegisterPaymentMethodInitReq } from '@/types/subscription';

export const useInitPaymentMethodRegistration = () => {
    return useMutation<NicePayAuthParams, unknown, RegisterPaymentMethodInitReq>({
        mutationFn: initPaymentMethodRegistration,
    });
};
